import React from "react";

/**
 * One labelled horizontal bar: label, filled track, "N% (count)".
 * The bar is decorative; the percentage text carries the value.
 */
const DistributionBar = ({ label, percent = 0, count = 0, barClassName = "bg-primary", labelClassName = "" }) => (
  <li className="flex items-center gap-3">
    <span className={`shrink-0 break-words text-sm font-medium text-fg ${labelClassName}`.trim()}>
      {label}
    </span>
    <span aria-hidden="true" className="h-6 flex-1 overflow-hidden rounded-full bg-surface-subtle">
      <span
        className={`block h-full rounded-full transition-all ${barClassName}`}
        style={{ width: `${percent}%` }}
      />
    </span>
    <span className="w-20 shrink-0 text-right text-sm font-medium text-fg">
      {percent}% ({count})
    </span>
  </li>
);

export default DistributionBar;
